import { useEffect, useState } from "react";
import moment from 'moment'
import { UtilityService } from "../../../services/UtilityService";
import { UpArrowBlackIcon, DownArrowBlackIcon } from "../../../icon";

interface IProps {
    handleChange: (time: number) => void;
    Value: number;
    IsMobileDevice: boolean;
    TextLabel?: string;
    MinuteStep?: number;
    HourStep?: number;
}

const ArrowTimeComponent = (props) => {
    const defaultProps: Partial<IProps> = {
        MinuteStep: 1,
        HourStep: 1,
    };

    let TimeValueLocal = props.Value !== -1 && new Date(props.Value)?.toString() !== "Invalid Date" ? new Date(props.Value) : UtilityService.getPreferredTimeZoneTimeNow();

    const [TimeValue, SetTimeValue] = useState(new Date(UtilityService.roundTimeToMinutes(TimeValueLocal.getTime(), props.MinuteStep)))
    const [selectedHour, setSelectedHour] = useState(-1);
    const [selectedMinute, setSelectedMinute] = useState(-1);
    const [meridian, setMeridian] = useState("");
    const [minutes, setMinutes] = useState("");

    useEffect(() => {
        setSelectedHour(calculateHour(moment(TimeValue).format(`HH:mm`)))
        setSelectedMinute(calculateMinutes(moment(TimeValue).format(`HH:mm`)))
        setMeridian(calculateMeridian(moment(TimeValue).format(`HH:mm`)))
        setMinutes(calculateMinutes(moment(TimeValue).format(`HH:mm`)).toString())
    }, [])

    const calculateMinutes = (time: any) => {
        const splittedTime = time && moment(time, "HH:mm").format("HH:mm").split(":");
        return Number(splittedTime[1]?.split(" ")[0] || 0);
    };

    const calculateHour = (time: any) => {
        const splittedTime = time && moment(time, "HH:mm").format("HH:mm").split(":");
        return Number(splittedTime[0]);
    };

    const calculateMeridian = (time: any) => {
        const hour = calculateHour(time);
        const meridian = moment().hour(hour).localeData().meridiem(hour, 0, true);
        return meridian;
    };

    const UpArrowHour = () => {
        let hours = (selectedHour + props.HourStep) % 24;
        setSelectedHour(hours)
        onSelectedTimeChange(hours, selectedMinute);
    }

    const DownArrowHour = () => {
        let hours = selectedHour - props.HourStep;
        if (hours < 0) {
            hours += 24;
        }
        setSelectedHour(hours)
        onSelectedTimeChange(hours, selectedMinute);
    }

    const onSelectedTimeChange = (selectedHour, mins) => {
        handleTimeClick(selectedHour, mins);
    }

    const handleTimeClick = (selectedHour, mins) => {
        let time = (selectedHour !== -1 && mins !== -1) ? new Date(new Date(UtilityService.getPreferredTimeZoneTimeNow().setHours(selectedHour)).setMinutes(mins)) : UtilityService.getPreferredTimeZoneTimeNow();
        time = time.toString() !== "Invalid Date" ? time : TimeValue;
        time = new Date(UtilityService.roundTimeToMinutes(time.getTime(), props.MinuteStep))
        SetTimeValue(TimeValue)
        props.handleChange(time.getTime());
    }

    const UpArrowMinute = () => {
        let mins = (selectedMinute + props.MinuteStep) % 60;
        setSelectedMinute(mins)
        onSelectedTimeChange(selectedHour, mins);
    }

    const DownArrowMinute = () => {
        let mins = (selectedMinute - props.MinuteStep);
        if (mins < 0) {
            mins += 60;
        }
        setSelectedMinute(mins)
        onSelectedTimeChange(selectedHour, mins)
    }

    return (
        <div>
            <div className={`d-flex justify-between  ${props.IsMobileDevice ? "" : ""}`}>

                <div className={`h5-regular  br-2 ${props.IsMobileDevice ? "py-1 ml-1" : "p-1"}`}>
                    HH
                </div>
                <div className={`my-auto h2-bold ${props.IsMobileDevice ? "py-1" : "p-1 "}`} ></div>
                <div className={`h5-regular br-2 ${props.IsMobileDevice ? "py-1 mr-1" : "p-1  "}`}>
                    MM
                </div>
            </div>

            <div className={`d-flex justify-between ${props.IsMobileDevice ? "" : ""}`}>
                <div>
                    <UpArrowBlackIcon className={`c-pointer ${props.IsMobileDevice ? "px-1" : "px-1"}`} onClick={UpArrowHour} />
                    <div className={"h4-bold time_header  bg-color-display-time br-2"}>
                        {`${UtilityService.maskSingleDigitWithZero(selectedHour)}`}
                    </div>
                    <DownArrowBlackIcon className={`c-pointer ${props.IsMobileDevice ? "px-1" : "px-1"}`} onClick={DownArrowHour} />
                </div>
                <div className="my-auto h2-bold">:</div>
                <div>
                    <UpArrowBlackIcon className={` c-pointer ${props.IsMobileDevice ? "px-1" : "px-1"}`} onClick={UpArrowMinute} />
                    <div className={"h4-bold time_header bg-color-display-time br-2"}>
                        {`${UtilityService.maskSingleDigitWithZero(selectedMinute)}`}
                    </div>
                    <DownArrowBlackIcon className={`c-pointer ${props.IsMobileDevice ? "px-1" : "px-1"}`} onClick={DownArrowMinute}
                    />
                </div>
            </div>
        </div>);
}

export default ArrowTimeComponent;